import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type HorizontalNavQueue from './ui/HorizontalNavQueue.tsx';

export const LazyHorizontalNavQueue = lazyAfterPaint<typeof HorizontalNavQueue>(
	() =>
		import(/* webpackChunkName: "async-horizontal-nav-queue" */ './ui/HorizontalNavQueue').then(
			(HorizontalNavQueue) => HorizontalNavQueue,
		),
	{ includeInShellOnlySsrBundle: true },
);
